import { render, staticRenderFns } from "./briefcaseStorageBreakdown.html?vue&type=template&id=fc5944fc&scoped=true&"
import script from "./briefcaseStorageBreakdown.js?vue&type=script&lang=js&"
export * from "./briefcaseStorageBreakdown.js?vue&type=script&lang=js&"
import style0 from "./briefcaseStorageBreakdown.scss?vue&type=style&index=0&id=fc5944fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5944fc",
  null
  
)

export default component.exports